import { http } from "../utils/http";

export const getPublicCandidateDocumentsForm = (token) => http.get(`/public/candidate-documents/${encodeURIComponent(token)}`, { auth: false });
export const openCandidateDocumentsUploadSession = (token, sessionToken = "") =>
    http.post(`/public/candidate-documents/${encodeURIComponent(token)}/upload-sessions`, {
        session_token: sessionToken || null,
    }, { auth: false });
export const uploadCandidateDocumentDraftFile = (token, sessionToken, entry) => {
    const body = new FormData();
    body.append("session_token", sessionToken);
    body.append("kind", entry.kind);
    body.append("file", entry.file, entry.file.name);
    return http.post(`/public/candidate-documents/${encodeURIComponent(token)}/upload-sessions/files`, body, { auth: false });
};
export const validateCandidateDocumentDraftFile = (token, sessionToken, fileId, signal) =>
    http.post(
        `/public/candidate-documents/${encodeURIComponent(token)}/upload-sessions/files/${encodeURIComponent(fileId)}/validate`,
        {},
        {
            auth: false,
            headers: { "X-Upload-Session": sessionToken },
            signal,
        },
    );
export const deleteCandidateDocumentDraftFile = (token, sessionToken, fileId) =>
    http.del(`/public/candidate-documents/${encodeURIComponent(token)}/upload-sessions/files/${encodeURIComponent(fileId)}`, {
        auth: false,
        headers: { "X-Upload-Session": sessionToken },
    });
export const submitPublicCandidateDocuments = (token, sessionToken, actualResidenceAddress) =>
    http.post(`/public/candidate-documents/${encodeURIComponent(token)}/upload-sessions/submit`, {
        session_token: sessionToken,
        actual_residence_address: actualResidenceAddress,
    }, { auth: false });
export const listCandidateDocuments = () => http.get("/candidate-documents");
export const generateCandidateDocumentsInvite = (candidateId, contractType = "employment") =>
    http.post(`/candidates/${candidateId}/documents/invite`, { contract_type: contractType });
export const completeCandidateDocuments = (id) => http.post(`/candidate-documents/${id}/complete`, {});
export const requestMoreCandidateDocuments = (id, payload) =>
    http.post(`/candidate-documents/${id}/request-more`, payload);
export const deleteCandidatePackageDocument = (packageId, documentId) =>
    http.del(`/candidate-documents/${packageId}/documents/${encodeURIComponent(documentId)}`);
export const returnCandidateFromDocuments = (packageId) =>
    http.post(`/candidate-documents/${packageId}/return-to-candidates`, {});
export const uploadCandidateDocumentManually = (candidateId, kind, file, actualResidenceAddress) => {
    const body = new FormData();
    body.append("candidate_id", String(candidateId));
    body.append("kind", kind);
    body.append("actual_residence_address", actualResidenceAddress);
    body.append("file", file, file.name);
    return http.post("/candidate-documents/manual", body);
};
export const getCandidateEmploymentRequisites = (candidateId) =>
    http.get(`/candidates/${candidateId}/employment-requisites`);
export const updateCandidateEmploymentRequisites = (candidateId, payload) =>
    http.patch(`/candidates/${candidateId}/employment-requisites`, payload);
export const regenerateCandidateContractsFromRequisites = (candidateId) =>
    http.post(`/candidates/${candidateId}/employment-requisites/regenerate`, {});
